import React, { useState, useEffect } from "react";
import Dropdown from "./Dropdown";
import UserInitials from "./UserInitials";
import SyncIcon from "@mui/icons-material/Sync";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import tick from "../assests/images/tick.svg";
import failed from "../assests/images/failed.svg";
import RefreshButton from "./utilities/RefreshButton";
import { Link } from "react-router-dom";
import axios from "../api/axios";
import LoadingGif from "../assests/images/loading.gif";
export default function RecentResults(props) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,setError] =useState("");
  const fetchItems = async () => {
    setLoading(true);
    axios.get("/api/get-recent-results")
    .then((res)=>{
      setItems(res.data.items);
      setLoading(false);
      })
      .catch((err) => {
        setError("Failed to fetch recent results.");
        setLoading(false);
      });
  }
  useEffect(()=>{
    fetchItems();
  },[])
  return (
    <div style={{ marginTop: "-5px" }}>
      <div className="d-flex row">
        {/* Recent Results Card */}
        <div className="col-12 col-xl-8" style={{ padding: "12px" }}>
          <div className="card result-cards mb-0" style={{ padding: "20px" }}>
            <div className="d-flex justify-content-between align-items-top">
              <span className="sub-step-light">Recent Results</span>
              <Link
                to="/results"
                style={{ textDecoration: "none", marginTop: "0.3rem" }}
                className="storage-limit para-dark-grey"
              >
                View All Results <ArrowForwardIcon fontSize="small" />
              </Link>
            </div>
            <RefreshButton onRefresh={()=>fetchItems()} className="d-flex justify-content-end align-items-center"/>
            <div className="table-responsive" style={{maxHeight: '400px'}}>
              <table className="table">
                <thead>
                  <tr>
                    <th
                      style={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: "#fff",
                        zIndex: 1,
                        color:"#434343",
                      }}
                      className="menu-options"
                    >
                      Job No.
                    </th>
                    <th className="menu-options" style={{color:"#434343"}}>Run Name</th>
                    <th className="menu-options" style={{color:"#434343",minWidth:"112px"}}>Run Type</th>
                    <th className="menu-options" style={{color:"#434343"}}> Date</th>
                    <th className="menu-options" style={{color:"#434343"}}>Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody style={{verticalAlign:"middle"}}>
                  {items.length > 0 ? (
                    items.map((item, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            position: "sticky",
                            left: 0,
                            backgroundColor: "#fff",
                            zIndex: 1,
                            padding:"14.5px 8px",
                            minWidth:"66px"
                          }}
                          className="menu-options"
                        >
                          {item.id}
                        </td>
                        <td className="menu-options" style={{padding:"14.5px 8px"}}>{item.runname}</td>
                        <td className="menu-options" style={{padding:"14.5px 8px"}}>{item.runtype}</td>
                        <td className="menu-options" style={{padding:"14.5px 8px"}}>
                          {formatDate(item.date)}
                        </td>
                        <td style={{padding:"14.5px 8px"}}>
                          <span style={{ marginLeft: "0.6rem", }}>
                            {item.status === 0 && <PendingActionsIcon />}
                            {item.status === 1 && (
                              <img src={tick} alt="Run Success" />
                            )}
                            {item.status === 2 && (
                              <img src={failed} alt="Run Failed" />
                            )}
                            {item.status === 3 && <SyncIcon />}
                          </span>
                        </td>
                        <td style={{ textAlign: "center",padding:"14.5px 8px" }} >
                          <Link
                            to="/results"
                            style={{ textDecoration: "none", color: "black" }}
                          >
                            <button className="details-btn storage-limit">
                              Details
                            </button>
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" style={{ textAlign: "center" }}>
                        { loading? <img src={LoadingGif} alt="loading..." height="96px"/> : error? error : "No results found."}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Account Overview and Token Overview Cards */}
        <div className="col-12 col-xl-4 d-md-flex d-xl-block p-0">
          {/* Account Overview */}
          <div
            className="col-12 col-md-6 col-xl-12"
            style={{ padding: "12px" }}
          >
            <div
              className="card result-cards mb-0"
              style={{ minHeight: "0", height: "100%", padding: "20px" }}
            >
              <p className="mb-3 sub-step-light">Account Overview</p>
              <div className="account-details">
                <div className="d-flex align-items-center mb-3">
                  <UserInitials
                    firstName={props.data.fname}
                    lastName={props.data.lname}
                  />
                  <p className="mb-0" style={{ margin: "0 0 0 12px" }}>
                    {props.data.fname} {props.data.lname}
                    <br />
                    <span className="sub-text text-break">
                      {props.data.email}
                    </span>
                  </p>
                </div>
                <span className="review-text small-text">
                  User Since
                  <br />
                </span>
                <span>{props.data.regdate?formatDateWithMonthName(props.data.regdate): "-"}</span>
              </div>
            </div>
          </div>

          {/* Token Overview */}
          <div
            className="col-12 col-md-6 col-xl-12"
            style={{ padding: "12px" }}
          >
            <div
              className="card result-cards mb-0"
              style={{ minHeight: "0", height: "100%", padding: "20px" }}
            >
              <p className="sub-step-light">Token Overview</p>
              <Dropdown />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const formatDateWithMonthName = (dateString) => {
  const dateObj = new Date(dateString);
  // Get month name
  const monthName = dateObj.toLocaleString('default', { month: 'long' });
  // Get last two digits of the year
  const year = dateObj.getFullYear();

  return `${monthName}, ${year}`;
};

const formatDate = (input) => {
  const date = new Date(input);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);
  return `${day}/${month}/${year}`;
};
